import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { setTokenGetter, setSignOutHandler } from '@/services/api';

interface ApiSetupProps {
  children: React.ReactNode;
}

export default function ApiSetup({ children }: ApiSetupProps) {
  const { getAccessToken, signOut } = useAuth();

  useEffect(() => {
    // Set up API token getter
    setTokenGetter(getAccessToken);
    setSignOutHandler(signOut);
  }, [getAccessToken, signOut]);

  return <>{children}</>;
}
